import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Tab, Tabs } from '@mui/material';
import PersonsPage from '@/features/persons/PersonsPage';
import CompaniesPage from '@/features/companies/CompaniesPage';
import { resolvePartyTab, type PartyTab } from './partiesTabs';

export default function PartiesPage() {
  const { t } = useTranslation('parties');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = resolvePartyTab(searchParams.get('tab'));

  const handleTabChange = useCallback((_: React.SyntheticEvent, value: PartyTab) => {
    const next = new URLSearchParams(searchParams);
    // 'persons' is the default tab and carries no ?tab param so its URL stays clean.
    if (value === 'persons') {
      next.delete('tab');
    } else {
      next.set('tab', value);
    }
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab value="persons" label={t('tabs.persons')} />
        <Tab value="companies" label={t('tabs.companies')} />
      </Tabs>

      {activeTab === 'persons' && <PersonsPage />}
      {activeTab === 'companies' && <CompaniesPage />}
    </Box>
  );
}
